import { createFileRoute,Outlet } from '@tanstack/react-router'
import { requireCapability } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'

export const Route = createFileRoute('/_dashboard/shifts')({
  beforeLoad: requireCapability('VIEW_REPORTS'),
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ShiftsLayout,
})

function ShiftsLayout() {
  return <Outlet />
}
